import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ArrowLeft, Close } from '@components/Icons';
import SimpleButton, { SIZE, COLOR } from '@components/SimpleButton';

import Title from '../Title';

export const INNER_HEADER_ID = 'inner_header';

const Container = styled.div`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spaces.space_20};
  min-height: 44px;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  ${({ theme }) => theme.fontFamily.mainFont.smallSemiBold};

  .title {
    padding-left: 4%;
    width: 96%;
    max-width: none;
  }
`;

const Icon = styled.img`
  justify-self: center;
  width: 44px;
  cursor: pointer;
`;

const StyledClose = styled(Close)`
  margin: 10px;
`;

const StyledArrowLeft = styled(ArrowLeft)`
  margin: 10px;
`;

const Action = styled(SimpleButton)`
  right: ${({ theme }) => theme.spaces.space_4};
  top: ${({ theme }) => theme.spaces.space_8};
  ${({ theme }) => theme.fontFamily.mainFont.smallExtraBold};
`;

const Subtitle = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.mediumRegular};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: 1.17;
  padding-left: ${({ theme }) => theme.constants.lateralSpace};
  padding-right: ${({ theme }) => theme.constants.lateralSpace};
  padding-top: ${({ theme }) => theme.spaces.space_8};
`;

function InnerHeader({
  id,
  icon,
  label,
  actionLabel,
  onActionClick,
  onClose,
  isModal,
  subtitle,
  className,
}) {
  let iconComponent;
  if (icon) iconComponent = <Icon onClick={onClose} src={icon} />;
  else
    iconComponent = isModal ? (
      <StyledClose onClick={onClose} size="large" />
    ) : (
      <StyledArrowLeft onClick={onClose} size="large" />
    );

  return (
    <Container id={id} className={className}>
      {iconComponent}

      {!!actionLabel && (
        <Action
          element_id="header__action"
          onClick={onActionClick}
          label={actionLabel}
          size={SIZE.SMALL}
          color={COLOR.TERTIARY}
        />
      )}

      <Title label={label} className="title" />
      {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Container>
  );
}

InnerHeader.propTypes = {
  // data
  id: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string.isRequired,
  actionLabel: PropTypes.string,
  subtitle: PropTypes.string,
  isModal: PropTypes.bool,
  className: PropTypes.string,

  // callbacks
  onClose: PropTypes.func,
  onActionClick: PropTypes.func,
};

InnerHeader.defaultProps = {
  id: INNER_HEADER_ID,
  isModal: false,
  className: '',
};

export default InnerHeader;
